import { TextField, Button, Select, FormControl, InputLabel } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import axios from 'axios'
import { useRecoilState } from 'recoil'
import { banksState } from '../../Banks/recoil/atoms'
import { accountsState } from '../recoil/atoms'
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    inputFields: {
        margin: 5
    },
});


const AddAccount = props => {
    const classes = useStyles()
    const [banks, setBanks] = useRecoilState(banksState)
    const [accounts, setAccounts] = useRecoilState(accountsState)
    const [branches, setBranches] = useState([])
    const [chequeSettings, setChequeSettings] = useState([])
    const [currentBranchID, setCurrentBranchID] = useState('')
    const getData = async () => {
        const banksData = await axios.get('accounts/bank/').then(result => result.data)
        const branchesData = await axios.get('accounts/branch/?bank_id=' + banksData[0].id).then(result => result.data)
        const chequeSettingsData = await axios.get('accounts/cheque_setting/').then(result => result.data)
        setBanks(banksData)
        setChequeSettings(chequeSettingsData)
        setBranches(branchesData)
        setCurrentBranchID(branchesData[0].id)
    }
    useEffect(() => {
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const formik = useFormik({
        initialValues: {
            title: '',
            owner: '',
            number: '',
            bank_id: '',
            cheque_setting_id: -1,
        },
        enableReinitialize: true,
        onSubmit: values => {
            const data = {
                branch_id: currentBranchID,
                number: values.number,
                title: values.title,
                owner: values.owner,
                cheque_setting_id: values.cheque_setting_id
            }
            if (Number(values.cheque_setting_id) === -1) {
                delete data.cheque_setting_id
            }
            axios.post('accounts/account/', data).then(result => {
                setAccounts([...accounts, result.data])
                props.setPopup(false)
            })
        }
    })

    const handleBankChange = event => {
        formik.handleChange(event)
        axios.get('accounts/branch/?bank_id=' + event.target.value)
            .then(result => {
                setBranches(result.data)
                setCurrentBranchID(result.data[0].id)
            })
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <TextField
                id="title"
                label="عنوان حساب"
                fullWidth
                value={formik.values.title || ''}
                onChange={formik.handleChange}
                required
                className={classes.inputFields}
            />
            <TextField
                id="owner"
                label="صاحب حساب"
                fullWidth
                value={formik.values.owner || ''}
                onChange={formik.handleChange}
                required
                className={classes.inputFields}
            />
            <TextField
                id="number"
                label="شماره حساب"
                fullWidth
                value={formik.values.number || ''}
                onChange={formik.handleChange}
                required
                className={classes.inputFields}
            />
            <FormControl fullWidth className={classes.inputFields}>
                <InputLabel htmlFor="bank_id">بانک</InputLabel>
                <Select
                    native
                    value={formik.values.bank_id || ''}
                    onLoad={handleBankChange}
                    onChange={handleBankChange}
                    inputProps={{
                        name: 'bank_id',
                        id: 'bank_id'
                    }}
                    required
                >
                    {banks.map(bank => (
                        <option key={bank.id} value={bank.id}>{bank.name || ''}</option>
                    ))}
                </Select>
            </FormControl>
            <FormControl fullWidth className={classes.inputFields}>
                <InputLabel htmlFor="branch_id">شعبه</InputLabel>
                <Select
                    native
                    value={currentBranchID || ''}
                    onChange={event => setCurrentBranchID(event.target.value)}
                    inputProps={{
                        name: 'branch_id',
                        id: 'branch_id'
                    }}
                    required
                >
                    {branches.map(branch => (
                        <option key={branch.id} value={branch.id}>{branch.name || ''}</option>
                    ))}
                </Select>
            </FormControl>
            <FormControl fullWidth className={classes.inputFields}>
                <InputLabel htmlFor="cheque_setting_id">نوع چک</InputLabel>
                <Select
                    native
                    value={formik.values.cheque_setting_id || ''}
                    onChange={formik.handleChange}
                    inputProps={{
                        name: 'cheque_setting_id',
                        id: 'cheque_setting_id'
                    }}
                >
                    <option value="-1">-</option>
                    {chequeSettings.map(chequeSetting => (
                        <option key={chequeSetting.id} value={chequeSetting.id}>{chequeSetting.title || ''}</option>
                    ))}
                </Select>
            </FormControl>
            <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                style={{ marginTop: 10 }}
                disabled={formik.isSubmitting}
            >
                اضافه کردن
            </Button>
        </form>
    )
}

export default AddAccount